(function () {
    'use strict';

    angular.module("imApp").factory("ediImportService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1153,
                    parameters: parms || {}
                });
            },
            listEdiSources: function (parms) {
                return $ihttp.post({
                    method: 978,
                    parameters: parms || {}
                });
            },
            listImportProcesses: function (parms) {
                return $ihttp.post({
                    method: 877,
                    parameters: parms || {}
                });
            },
            processEdiImport: function (edit) {
                return $ihttp.post({
                    method: 1156,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1154,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1155,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
